import React, { useState, useEffect, useRef, useMemo } from "react";

import BulkRequestZipDocumentTable from "../../../../../bulk/request/zip/document/table";

import { getByIds as getCorporateAgreementDocumentByIds } from "../../../../agreement_document/axios";
import { create } from "../../../../../corporate/bulk/request/zip/document/axios";

import { limitCharacters } from "../../../../../helper/form"

const CorporateBulkRequestZipDocumentForm = props => {
  const { companies, documentTypes, aasmStates } = props?.filters;
  const [bulkRequest, setBulkRequest] = useState(props?.bulkRequest);

  const dataTableDefaultColumns = [
    {
      field: "entity.identifier",
      header: I18n.t("activerecord.attributes.corporate/agreement.identifier"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el identificador del ${I18n.t(
          "activerecord.models.corporate/agreement.one"
        )}`,
        filterrific: {
          search: "search_by_agreement_identifier"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "agreement_identifier_"
        }
      }
    },
    {
      field: "entity.client.company_config.name",
      header: I18n.t("activerecord.attributes.corporate/agreement.client"),
      filter: {
        enabled: true,
        placeholder: `Selecciona un ${_.lowerCase(I18n.t("activerecord.attributes.corporate/agreement.client"))}`,
        inputType: 'simple_select',
        filterrific: {
          search: "by_client",
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name
        }))
      }
    },
    {
      field: "entity.provider.company_config.name",
      header: I18n.t("activerecord.attributes.corporate/agreement.provider"),
      filter: {
        enabled: true,
        placeholder: `Selecciona un ${_.lowerCase(I18n.t("activerecord.attributes.corporate/agreement.provider"))}`,
        inputType: 'simple_select',
        filterrific: {
          search: "by_provider",
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name
        }))
      }
    },
    {
      field: "entity.start_date_to_s",
      header: I18n.t("activerecord.attributes.corporate/agreement.start_date"),
    },
    {
      field: "entity.end_date_to_s",
      header: I18n.t("activerecord.attributes.corporate/agreement.end_date"),
    },
    {
      field: "label",
      header: I18n.t("activerecord.attributes.corporate/agreement_document.label"),
      filter: {
        enabled: true,
        placeholder: `Ingrese ${I18n.t("activerecord.attributes.corporate/agreement_document.label")}`,
        filterrific: {
          search: "search_by_label"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "label_"
        }
      }
    },
    {
      field: "document_type.name",
      header: I18n.t("activerecord.attributes.corporate/agreement_document.document_type"),
      filter: {
        enabled: true,
        placeholder: `Seleccione un tipo de documento`,
        inputType: 'simple_select',
        options: _.map(documentTypes, document_type => ({
          value: document_type.id,
          label: document_type.name,
        })),
        filterrific: {
          search: "by_document_type"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "document_type_name_"
        }
      }
    },
    {
      field: "created_at_to_s",
      header: I18n.t("activerecord.attributes.corporate/agreement_document.created_at"),
      filter: {
        enabled: true,
        placeholder: `Ingrese la ${I18n.t(
          "activerecord.attributes.corporate/agreement_document.created_at"
        )}`,
        filterrific: {
          search: "search_by_created_at"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "created_at_to_s_"
        }
      }
    },
    {
      field: "aasm_state",
      header: I18n.t("activerecord.attributes.document.aasm_state.one"),
      body: (row) => I18n.t(`activerecord.attributes.document.aasm_state.${row.aasm_state}`),
      filter: {
        enabled: true,
        placeholder: `Seleccione un estado`,
        inputType: 'simple_select',
        options: aasmStates,
        filterrific: {
          search: "by_aasm_state"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "aasm_state_"
        }
      }
    }
  ]

  const dataTableCustomFieldsColumns = useMemo(() => {
    return _.map(props?.customFields, function (customField) {
      return {
        field: `entity.custom_fields.${customField.code}`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return limitCharacters(row.entity.custom_fields[customField.code])
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${_.capitalize(customField.label)}`,

          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [props?.customFields])

  const agreementDocumentsColumns = useMemo(() => {
    let columns = _.concat(
      dataTableDefaultColumns,
      dataTableCustomFieldsColumns
    )

    return _.compact(columns)
  }, [])

  const tableConfirmDocument = (documents, drawDeleteSelectedDocument) => {
    return (
      <div className="d-flex">
        <table className="table mt-2 table-responsive-md">
          <thead>
            <tr>
              <th>
                {I18n.t("activerecord.attributes.corporate/agreement_document.label")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.corporate/agreement_document.document_type")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.corporate/agreement.client")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.corporate/agreement.provider")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.corporate/agreement.start_date")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.corporate/agreement.end_date")}
              </th>
            </tr>
          </thead>
          <tbody>
            {_.map(documents, function (document, index) {
              return (
                <tr key={`tr-list-documents-${document.id}`}>
                  <td>{document?.label || I18n.t("no_entry")}</td>
                  <td>{document?.document_type?.name}</td>
                  <td>{document?.entity?.client?.company_config?.name || I18n.t('unassigned')}</td>
                  <td>{document?.entity?.provider?.company_config?.name || I18n.t('unassigned')}</td>
                  <td>{document?.entity?.start_date_to_s || I18n.t("no_entry")}</td>
                  <td>{document?.entity?.end_date_to_s || I18n.t("undefined")}</td>
                  <td>{drawDeleteSelectedDocument(document)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div>
      <BulkRequestZipDocumentTable
        showBulkMyFilter={false}
        bulkRequest={bulkRequest}
        dataTableConfiguration={{
          columns: agreementDocumentsColumns
        }}
        tableConfirmDocument={tableConfirmDocument}
        configuration={{
          context: "corporate",
          defaultRequestParams: {},
        }}
        actions={{
          indexDocumentsPath: Routes.corporate_agreement_documents_path,
          createService: create,
          getDocumentByIds: getCorporateAgreementDocumentByIds
        }}
        buttonActions={{
          show: Routes.corporate_bulk_request_zip_document_path,
          back: Routes.corporate_bulk_request_zip_documents_path(),
        }}
      />
    </div>
  );
};

export default CorporateBulkRequestZipDocumentForm;
